import * as utils from '@utils/form';

export const FORM_FIELD = {
  ARTICLES: {
    name: 'slides',
    label: 'Current articles',
    rules: [{ min: 1, max: 30 }],
    serialize: (field, values) => {
      const value = values[field.name];
      return value ? { [field.name]: value.map(({ id }) => ({ articleId: id?.split('_')[0] || id })) } : null;
    },
  },
  TAG: {
    name: 'tag',
    label: 'Filter by content tag',
    rules: [{ required: true, message: 'A content tag is required' }],
    serialize: utils.relatedEntitySerializer,
  },
};
export const FORM_FIELDS = Object.values(FORM_FIELD);

export const MODE = {
  MANUAL: {
    value: 'manually',
    label: 'Choose articles manually',
  },
  AUTOMATIC: {
    value: 'automatically',
    label: 'Choose articles automatically',
  },
};
export const MODES = Object.values(MODE);

export const INITIAL_VALUES = {
  [FORM_FIELD.ARTICLES.name]: [],
};
